import { FixaToast } from "@coworker/apprestructured/src/shared/wrappers/FixaToast/FixaToast";
import { useTranslation } from "@coworker/locales";
import { ToastNotificationItem } from "./hooks/useToastNotificationsState";
import styles from "./ToastStack.module.css";

type ToastStackProps = {
  notifications: ToastNotificationItem[];
  removeToast: (notificationId: number) => void;
};

export const ToastStack = ({ notifications, removeToast }: ToastStackProps) => {
  const { t } = useTranslation();

  if (notifications.length === 0) {
    return null;
  }

  return (
    <div className={styles["root"]} data-testid="task-viewer-toast-container">
      {notifications.map((notification) => (
        <FixaToast
          key={notification.id}
          text={notification.text}
          isOpen
          onCloseRequest={() => removeToast(notification.id)}
          ariaLabelCloseBtn={t("dismissNotificationString")}
        />
      ))}
    </div>
  );
};
